var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kl-faq__container container",style:({ minHeight: '80vh' })},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('section',{staticClass:"kl-faq-list"},[_c('KeepAlive',[_c(_vm.translateComponent,{tag:"component"})],1)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }